import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';

/** Секция detail-страницы: карточка с заголовком. */
export function Section({
  title,
  children,
  action,
}: {
  title: string;
  children: ReactNode;
  action?: ReactNode;
}): JSX.Element {
  return (
    <Card variant="outlined">
      <CardHeader title={title} titleTypographyProps={{ variant: 'h6' }} action={action} />
      <CardContent sx={{ pt: 0 }}>{children}</CardContent>
    </Card>
  );
}

/** Строка «метка: значение» для карточек свойств. */
export function FieldRow({ label, value }: { label: string; value: ReactNode }): JSX.Element {
  return (
    <Typography variant="body2" sx={{ display: 'flex', gap: 1, py: 0.25 }} component="div">
      <Typography component="span" variant="body2" color="text.secondary" sx={{ minWidth: 160 }}>
        {label}
      </Typography>
      <span>{value ?? '—'}</span>
    </Typography>
  );
}

/** Заглушка пустой секции. */
export function EmptyHint({ text }: { text: string }): JSX.Element {
  return (
    <Typography variant="body2" color="text.secondary">
      {text}
    </Typography>
  );
}
